import React, { useState, useEffect } from "react";
import { Table, Card, Spin, Empty, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

const FunctionHierarchy = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    const fetchFunctionHierarchy = async () => {
        setLoader(true);
        try {
            const FORM_DATA = new FormData();
            const res = await post(ApiURL.function_hierarchy, FORM_DATA);
            if (res?.status === true) {
                setDataSource(res?.data || res?.response_data || []);
            } else {
                setDataSource([]);
            }
        } catch (error) {
            console.error("Error fetching function hierarchy:", error);
            setDataSource([]);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchFunctionHierarchy();
    }, []);

    const columns = [
        {
            title: "FUNCTION NAME",
            dataIndex: "name",
            key: "name",
            width: "70%",
            render: (text) => <span style={{ fontWeight: '500', textTransform: 'uppercase' }}>{text}</span>
        },
        {
            title: "CODE",
            dataIndex: "function_number",
            key: "function_number",
            align: 'center',
            width: "30%",
            render: (text) => <span style={{ color: '#555' }}>{text || "N/A"}</span>
        },
        {
            title: "ACTION",
            key: "action",
            align: 'center',
            width: "20%",
            render: (_, record) => {
                if (record.opened) {
                    return (
                        <Button 
                            type="primary" 
                            size="small" 
                            onClick={(e) => {
                                e.stopPropagation();
                                navigate("/add-machinery", { state: { functionCode: record.function_number, functionName: record.name } });
                            }}
                            style={{ backgroundColor: '#D91D3B', borderColor: '#D91D3B' }}
                        >
                            Go to Components
                        </Button>
                    );
                }
                return null;
            }
        }
    ];

    const handleExpand = (expanded, record) => {
        const key = record.function_number;
        if (expanded) {
            // Keep only keys that are parents of the newly expanded key
            const newKeys = expandedRowKeys.filter(k => key.startsWith(k));
            setExpandedRowKeys([...newKeys, key]);
        } else {
            
            // Remove the key and all its descendants from the expanded keys
            setExpandedRowKeys(expandedRowKeys.filter(k => k !== key && !k.startsWith(key)));
        }
    };

    return (
        <div className="white-container" style={{ padding: "10px" }}>
            <div className="row" style={{ padding: "15px 10px" }}>
                <div className="col-12">
                    <div className="theme-content-title text-left">
                        <h3 style={{ margin: 0, color: '#001529' }}>Function Hierarchy</h3>
                    </div>
                </div>
            </div>

            <Card style={{ marginTop: '10px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                {loader ? (
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        <Spin size="large" />
                    </div>
                ) : dataSource.length > 0 ? (
                    <Table 
                        columns={columns} 
                        dataSource={dataSource} 
                        rowKey="function_number"
                        bordered
                        pagination={false}
                        expandedRowKeys={expandedRowKeys}
                        onExpand={handleExpand}
                        expandable={{
                            defaultExpandAllRows: false,
                            expandRowByClick: true,
                        }}
                        className="custom-table hierarchy-table clickable-rows"
                        style={{ background: '#fff' }}
                    />
                ) : (
                    <Empty description="No hierarchical data found" />
                )}
            </Card>

            <style>
                {`
                    .clickable-rows .ant-table-row {
                        cursor: pointer;
                    }
                    .hierarchy-table .ant-table-cell {
                        padding: 12px 16px !important;
                    }
                `}
            </style>
        </div>
    );
};

export default FunctionHierarchy;
